import React from 'react';
import { map, get } from 'lodash-es';
import './SummaryBlock.scss';
import PropTypes from 'prop-types';
import useReducer from '../../Utils/useReducer';
import reducer from './SummaryBlock.reducer';
import { initializeState } from './SummaryBlock.transform';
import { listShape, styleShape, styleDefault } from './SummaryBlock.shape';
import List from './Blocks/List';

/**
 * @param {*} props
 */
const SummaryBlock = ({ list, style }) => {
  const initialState = initializeState({ list });
  const [state] = useReducer(reducer, initialState);

  return (
    <div className="summary-block-6a9-064f417-50f4-00f8-4e7b">
      {map(state, item => (
        <List
          key={get(item, 'id')}
          style={style}
          id={get(item, 'id')}
          title={get(item, 'title')}
          questions={get(item, 'questions')}
        />
      ))}
    </div>
  );
};

SummaryBlock.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape(listShape)).isRequired,
  style: PropTypes.shape(styleShape),
};

SummaryBlock.defaultProps = styleDefault;

export default SummaryBlock;
